import { defineMessages } from 'react-intl';

/**
 * Message descriptors for UploadLinks nav items. Used with $t to show localized labels.
 */
export const uploadLinksMessages = defineMessages({
  adAudios: {
    id: 'audit.filesUpload.links.adAudios',
    defaultMessage: 'Ad audios',
  },
  adSchedulesPlk: {
    id: 'audit.filesUpload.links.adSchedulesPlk',
    defaultMessage: 'Ad schedules (PLK)',
  },
  adSchedulesAsc: {
    id: 'audit.filesUpload.links.adSchedulesAsc',
    defaultMessage: 'Ad schedules (ASC)',
  },
  liveMentionSchedulesCsv: {
    id: 'audit.filesUpload.links.liveMentionSchedulesCsv',
    defaultMessage: 'Live Mention Schedules (CSV)',
  },
  bcrUpload: {
    id: 'audit.filesUpload.links.bcrUpload',
    defaultMessage: 'BCR upload',
  },
  ltxUpload: {
    id: 'audit.filesUpload.links.ltxUpload',
    defaultMessage: 'LTX upload',
  },
  avgUpload: {
    id: 'audit.filesUpload.links.avgUpload',
    defaultMessage: 'AVG upload',
  },
});
